import React from 'react';
import { LinkProps } from '@mui/material';
import { DateTime } from 'luxon';
import ZeusLink from './ZeusLink';

interface ZeusSessionLinkProps extends Omit<LinkProps, 'href' | 'children'> {
  session: {
    id: number;
    scheduledAt: string;
  };
}

function formatSessionDateTime(scheduledAt: string) {
  const date = DateTime.fromISO(scheduledAt);
  const dateString = date.toFormat('MMM d, yyyy');
  const timeString = date.toFormat('h:mm a');
  return `${dateString} • ${timeString}`;
}

export default function ZeusSessionLink({ session, ...linkProps }: ZeusSessionLinkProps) {
  return (
    <ZeusLink path={`/sessions/${session.id}`} {...linkProps}>
      {formatSessionDateTime(session.scheduledAt)}
    </ZeusLink>
  );
}
